import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'
import { firebaseUi, firebaseUiConfig } from '../firebase/'
import { checkLogin } from '../actions'

class Login extends Component {
  componentWillMount() {
    this.props.checkLogin()
  }
  componentDidMount() {
    firebaseUi.start('#firebaseui-auth-container', firebaseUiConfig)
  }
  render() {
    const { uid } = this.props
    return (
      uid ? <Redirect to="/"/> : <div id="firebaseui-auth-container"></div>
    )
  }
}
export default connect(
  state => ({ uid: state.user.uid }), 
  { checkLogin } 
)(Login)


// WEBPACK FOOTER //
// ./src/containers/Login.js